import React from 'react';
import '../styles/SchedulesList.css';

function SchedulesList({ schedules, onExecute, onCancel, disabled }) {
  const getTokenName = (address) => {
    const addr = address.toLowerCase();
    const names = {
      '0xc7de83ac4c2971dca2828ea0782b5a9706d30598': 'USDC',
      '0x9e00a7f73e9782e20a28898eb80400dc4ea33e2b': 'USDT',
      '0x8c00df228db94e67ef03dfdadcd68c2931c0effa': 'DAI',
      '0x8dde1de10af0d0b69e869076d8804d84d1f3f099': 'EURC',
    };
    return names[addr] || address.substring(0, 6) + '...';
  };

  const formatInterval = (seconds) => {
    if (seconds >= 2592000) return `${Math.round(seconds / 2592000)} month(s)`;
    if (seconds >= 604800) return `${Math.round(seconds / 604800)} week(s)`;
    if (seconds >= 86400) return `${Math.round(seconds / 86400)} day(s)`;
    return `${Math.round(seconds / 3600)} hour(s)`;
  };

  const isExecutable = (schedule) => {
    return schedule.active && Date.now() / 1000 >= schedule.nextExecutionTime;
  };

  return (
    <div className="schedules-list">
      {schedules.map((schedule) => (
        <div key={schedule.id} className={`schedule-card ${schedule.active ? 'active' : 'inactive'}`}>
          <div className="schedule-header">
            <h3>
              {schedule.name || `Schedule #${schedule.id}`}
              <span className="schedule-token-badge">{getTokenName(schedule.token)}</span>
            </h3>
            <span className={`schedule-status ${schedule.active ? 'active' : 'inactive'}`}>
              {schedule.active ? '🔄 Active' : '⏹ Complete'}
            </span>
          </div>

          <div className="schedule-details">
            <div className="detail">
              <label>Amount per lock:</label>
              <strong>{schedule.amount} {getTokenName(schedule.token)}</strong>
            </div>
            <div className="detail">
              <label>Interval:</label>
              <strong>Every {formatInterval(schedule.interval)}</strong>
            </div>
            <div className="detail">
              <label>Lock duration:</label>
              <strong>{formatInterval(schedule.lockDuration)}</strong>
            </div>
            <div className="detail">
              <label>Progress:</label>
              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${(schedule.executedCount / schedule.totalExecutions) * 100}%` }}
                />
              </div>
              <small>{schedule.executedCount} / {schedule.totalExecutions} executed</small>
            </div>
            {schedule.active && (
              <div className="detail">
                <label>Next execution:</label>
                <strong>
                  {isExecutable(schedule)
                    ? 'Ready now!'
                    : new Date(schedule.nextExecutionTime * 1000).toLocaleString()}
                </strong>
              </div>
            )}
          </div>

          {schedule.active && (
            <div className="schedule-actions">
              <button
                onClick={() => onExecute(schedule.id)}
                disabled={disabled || !isExecutable(schedule)}
                className={`btn-execute ${isExecutable(schedule) ? '' : 'btn-disabled'}`}
              >
                {isExecutable(schedule) ? '▶ Execute Now' : '⏳ Waiting...'}
              </button>
              <button
                onClick={() => onCancel(schedule.id)}
                disabled={disabled}
                className="btn-cancel-schedule"
              >
                ✕ Cancel Schedule
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default SchedulesList;
